import { atom } from 'recoil';

import { firstYear, yearsQuery } from './selector';

export declare namespace HomeStateTypes {
  interface Global {
    valueVisibility: boolean;
  }
}

export const homeGlobalState = atom<HomeStateTypes.Global>({
  key: 'homeGlobalState',
  default: {
    valueVisibility: false,
  },
});

export const yearsState = atom({
  key: 'Home/Customers/Years',
  default: yearsQuery,
});

export const selectedBigNumbersYearState = atom<string>({
  key: 'Home/Customers/SelectedBigNumbersYear',
  default: firstYear,
});

export const selectedAccountsPerformanceYearState = atom<string>({
  key: 'Home/Customers/SelectedAccountsPerformanceYear',
  default: firstYear,
});

export const selectedCustomersActivationYearState = atom<string>({
  key: 'Home/Customers/SelectedCustomersActivationYear',
  default: firstYear,
});

export const selectedActivationsByProfileYearState = atom<string>({
  key: 'Home/Customers/SelectedActivationsByProfileYear',
  default: firstYear,
});
